import { getAggregatedPropertyDataPoints } from './getAggregatedPropertyDataPoints';
import { getHistoricalPropertyDataPoints } from './getHistoricalPropertyDataPoints';
import { getLatestPropertyDataPoint } from './getLatestPropertyDataPoint';
export class SiteWiseClientEdge {
    constructor(siteWiseSdk) {
        this.siteWiseSdk = siteWiseSdk;
    }
    getLatestPropertyDataPoint(params) {
        return getLatestPropertyDataPoint({
            client: this.siteWiseSdk,
            ...params,
        });
    }
    getHistoricalPropertyDataPoints(params) {
        return getHistoricalPropertyDataPoints({
            client: this.siteWiseSdk,
            ...params,
        });
    }
    getAggregatedPropertyDataPoints(params) {
        return getAggregatedPropertyDataPoints({
            client: this.siteWiseSdk,
            ...params,
        });
    }
}
